<script>
  import * as restfulService from '../../../services/restfulService'

  import {mapActions} from 'vuex'
  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  export default {
    mixins: [helpers],
    name: 'dashboard-graduacao-i-popup',
    data () {
      return {
        popup: {
          id: null,
          nome: '',
          imagem: ''
        },
        senha: '',
        popupId: '',
        mostrarModal: false,
        mostrarModalSenha: false
      }
    },
    mounted () {
      // this.buscarPopup()
    },
    computed: {
      isMobileSize: function () {
        return this.isMobile().any()
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      buscarPopup () {
        restfulService.get('dashboard', 'popup-graduacao-i')
          .then(response => {
            this.mostrarModal = response.length > 0
          })
          .catch(e => {
            console.log(e)
          })
      },
      abrirModalSenha () {
        this.mostrarModalSenha = true
        setTimeout(() => {
          this.$refs.refSenha.focus()
        }, 200)
      },
      migrarGraduacaoI () {
        restfulService.post('migracao-curriculo', 'migrar-graduacao-i')
          .then(() => {
            bus.$emit('hide-loader')
            this.mostrarModal = false
            this.mostrarModalSenha = false
            this.showNotification({
              message: 'Sua solicitação de migração foi registrada'
            })
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.mostrarModal = false
            this.mostrarModalSenha = false
            console.log(e)
          })
      },
      verificarUsuario () {
        bus.$emit('show-loader')
        const data = {senha: this.senha}
        restfulService.post('usuario', 'verificar-senha', null, data)
          .then(response => {
            if (response.user) {
              this.migrarGraduacaoI()
            } else {
              bus.$emit('hide-loader')
              this.showNotification({
                title: 'Ops!',
                message: 'Sua senha não parece estar correta',
                type: 'error'
              })
            }
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div>
        <v-dialog v-model="mostrarModal"
                  :width="isMobileSize ? '90%' : '40%'">
            <v-card class="popup-modal">
                <v-container>
                    <h3 class="display-1">Graduação I</h3>
                    <div class="text">
                        <p class="subheading">Em design gráfico e editoração, Lorem ipsum é um texto utilizado para
                            preencher o espaço de texto em publicações (jornais, revistas, e websites)</p>
                        <ul>
                            <li>Item 1</li>
                            <li>Item 2</li>
                            <li>Item 3</li>
                        </ul>
                    </div>
                    <div style="text-align: center;">
                        <v-btn color="success" large @click="abrirModalSenha">Desejo Migrar para a Graduação
                            I
                        </v-btn>
                    </div>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="mostrarModalSenha"
                  :width="isMobileSize ? '80%' : '30%'">
            <v-card>
                <v-card-title class="primary white--text">
                    Confirmação de Senha
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="senha"
                                  ref="refSenha"
                                  type="password"
                                  label="Senha"/>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success"
                           @click="verificarUsuario">
                        Verificar Senha
                    </v-btn>
                    <v-btn flat @click="mostrarModalSenha = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>



// WEBPACK FOOTER //
// GraduacaoIPopup.vue?471f2965